/**
 * Created by USER on 18/6/19.
 */
import Swagger from 'swagger-client';


const httpClient = {
  client: new Swagger({
    url: 'https://api.lubanso.com:8000/api/v1/swagger.json',
    usePromise: true
  }),
  resBack(res, callback) {
    callback(res);
  },
  setAccesskey(ak) {
    console.log(ak, 11111111111);
    return new Promise((resolve) => {
      httpClient.client.then((client) => {
        // client.clientAuthorizations.remove('ApiKeyAuth');
        client.clientAuthorizations.add('ApiKeyAuth', new Swagger.ApiKeyAuthorization('x-token', ak, 'header'));
        // localStorage.setItem("access_key",ak);
        resolve(true);
      });
    });
  }
};

export default httpClient;
